(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "67fa85fcfea772a21905ac54";
              window.beaePageSetting.pageTitle = "footer"; 
              window.beaePageSetting.pageType = "footer";

          let js_OPS4NJ1V = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-go11a207section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-go11a207',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-go11a207');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-go11a207: ', ex)
      };
    

      try {
        let argid = 'beae-nwnqtxsdsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nwnqtxsd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nwnqtxsd');
        args.el = args.els[0];
        ((m) => { window.BeaeSlider&&!m.noRunJs&&window.BeaeSlider(m) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nwnqtxsd: ', ex)
      };
    

      try {
        let argid = 'beae-g4g4eth4section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-g4g4eth4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-g4g4eth4');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-g4g4eth4: ', ex)
      };
    

      try {
        let argid = 'beae-m3lzmd3ylinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-m3lzmd3y',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-m3lzmd3y');
        args.el = args.els[0];
        ((v) => { const b=v.el.querySelector(".beae-linkslist-title"),w=v.el.querySelector(".beae-linkslist");b===null||w===null||b.addEventListener("click",h=>{window.matchMedia("(max-width: 767px)").matches&&w.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-m3lzmd3y: ', ex)
      };
    

      try {
        let argid = 'beae-14pe4fvqlinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-14pe4fvq',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-14pe4fvq');
        args.el = args.els[0];
        ((v) => { const b=v.el.querySelector(".beae-linkslist-title"),w=v.el.querySelector(".beae-linkslist");b===null||w===null||b.addEventListener("click",h=>{window.matchMedia("(max-width: 767px)").matches&&w.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-14pe4fvq: ', ex)
      };
    

      try {
        let argid = 'beae-m8sxs533linkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-m8sxs533',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-m8sxs533');
        args.el = args.els[0];
        ((v) => { const b=v.el.querySelector(".beae-linkslist-title"),w=v.el.querySelector(".beae-linkslist");b===null||w===null||b.addEventListener("click",h=>{window.matchMedia("(max-width: 767px)").matches&&w.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-m8sxs533: ', ex)
      };
    

      try {
        let argid = 'beae-xj7qj02tlc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xj7qj02t',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xj7qj02t');
        args.el = args.els[0];
        ((g) => { let m=g.checkLive;function u(y){return{input:y.querySelector('input[name="locale_code"], input[name="country_code"]'),button:y.querySelector("button.beae-current-value"),panel:y.querySelector(".beae-language-results"),search:y.querySelector('input[name="language_filter"]'),resetButton:y.querySelector(".beae-reset-button")}}function v(y,$){const V=g.el.querySelector("form.beae-localization");$.input.value=y.currentTarget.dataset.value,V&&V.submit()}function b(y){y.button.focus(),y.panel.toggleAttribute("hidden"),y.button.setAttribute("aria-expanded",(y.button.getAttribute("aria-expanded")==="false").toString());const $=y.button.getBoundingClientRect();window.innerHeight-$.bottom<y.panel.offsetHeight?(y.panel.style.top="auto",y.panel.style.bottom="100%"):(y.panel.style.top="100%",y.panel.style.bottom="auto")}function w(y){return y.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function h(y,$){const V=w($.search.value),L=y.querySelectorAll(".beae-languages li");L.length,$.resetButton.classList.toggle("hidden",!V),L.forEach(T=>{w(T.querySelector(".beae-language-name").textContent).indexOf(V)>-1?T.classList.remove("beae-hidden"):T.classList.add("beae-hidden")})}function _(y){y.code.toUpperCase()==="ENTER"&&y.preventDefault()}function C(y,$,V){y.stopPropagation(),V.search.value="",h($,V)}function M(y,$,V){(!$.contains(y.target)||!$.contains(y.relatedTarget))&&(B($,V),V.button.setAttribute("aria-expanded",(V.button.getAttribute("aria-expanded")==="false").toString()))}function B(y,$){$.panel.setAttribute("hidden",!0),$.search&&($.search.value="",h(y,$))}function S(y){const $=u(y);m&&y.addEventListener("focusout",V=>M(V,y,$)),$.button.addEventListener("click",()=>b($)),y.querySelectorAll(".beae-language-name").forEach(V=>V.addEventListener("click",L=>v(L,$))),$.search&&($.search.addEventListener("keyup",()=>h(y,$)),$.search.addEventListener("keydown",_)),$.resetButton&&($.resetButton.addEventListener("click",V=>C(V,y,$)),$.resetButton.addEventListener("mousedown",V=>V.preventDefault()))}g.el.querySelectorAll(".beae-localization").forEach(S) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xj7qj02t: ', ex)
      };
    

      try {
        let argid = 'beae-aqpsoy8tsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-aqpsoy8t',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-aqpsoy8t');
        args.el = args.els[0];
        ((m) => { window.BeaeSlider&&!m.noRunJs&&window.BeaeSlider(m) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-aqpsoy8t: ', ex)
      };
    }; if (window.BEAEBASE) {js_OPS4NJ1V()} else {window.BEAEPAGEJS.push(js_OPS4NJ1V)} })(); 